<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 模块1 -->
    <!-- <div class="title-box">
      <p>首页</p>
      <div class="line">/</div>
      <p>个人中心</p>
      <div class="line">/</div>
      <p>详情</p>
      <div class="line">/</div>
      <p>正文</p>
    </div> -->

    <div class="box-content">
      <p>
        有人说:“老师是座灯塔，为我们照亮前方的道路;老师像只蜡烛，燃烧了自己，却成为照亮别人的人。”还有人说:“老师是辛勤的园丁，用自己的心血和汗水浇灌着我们。
      </p>
      <P>
        <span>发表时间：2023-11-07</span>
        <!-- <span>关键词：高考政策</span> -->
      </P>

      <p>
       本政策适用于西藏天利教育科技有限公司 （以下简称“我们”或“天利教育”）的天利教育系列产品（以下简称“产品”）或服务，包括天利教育网页端、天利教育教师端。
我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
请在使用我们的产品（或服务）前，仔细阅读并了解本政策，并确认了解我们对您个人信息的处理规则。一旦您点击确认接受本政策或在隐私政策更新后，您继续使用本产品，即表示您认可并接受本政策（含更新版本）的所有内容，并同意我们按本政策收集、使用、保存、共享、转让或披露您的相关个人信息。
本政策将帮助您了解以下内容：
一、定义与解释
二、我们如何收集和使用您的个人信息
三、我们如何使用 Cookie 和同类技术
四、我们如何共享、转让、公开披露您的个人信息
五、我们如何存储和保护您的个人信息
六、您的权利
七、我们如何处理未成年人的个人信息
八、您的个人信息如何在全球范围转移
九、本政策如何更新
十、如何联系我们
一、定义与解释
个人信息
个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码。为免疑义，个人信息包括但不限于个人敏感信息。
个人敏感信息
个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。个人敏感信息包括但不限于身份证件号码、个人生物识别信息、银行账户、通信内容、健康生理信息。
个人信息主体
个人信息主体指个人信息所标识的自然人
去标识化
去标识化指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
匿名化
匿名化指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
设备
设备是指可用于访问我们服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。
唯一设备标识符
唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（移动设备的 IMEI 号）。唯一设备标识符有多种用途，包括可在不能使用cookies时用以提供广告。
IP地址
每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。
GPS
Global Positioning System（全球定位系统）的简称。您使用的设备上的GPS信号接收器可以从GPS卫星收到信号并利用传来的信息计算您的位置。
WIFI
Wi-Fi是一种允许电子设备连接到一个无线局域网（WLAN）的技术，通常我们所说的无线网络。
基站
基站，即公用移动通信基站，是无线电台站的一种形式，是指在一定的无线电覆盖区中，通过移动通信交换中心，与移动电话终端之间进行信息传递的无线电收发信电台。
SSL
SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。
信息收集技术
本政策中所述的“自动收集”包括以下方式：
1）Cookie
Cookie是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个小小的文本文件，可用于改善您的使用体验。
2）Web beacon（网络信标）
Web beacon是装嵌在网站或电邮内的电子图像文件案或其他技术，可用于计算访客数目、记录您是否及何时阅览电邮或网站，或用以使用某些Cookie。
3）Log files（日志文件）
Log files储存自动收集的若干数据。该等数据包括互联网协议（IP）地址、浏览器类型、互联网服务提供商（ISP）、引用/退出页面、操作系统、日期/时间戳和点击流数据等。
4）ET Tag（实体标签）
ET Tag是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie，用以追踪个别使用者，使我们可更深入地了解和改善我们的服务。
5）JavaScript
JavaScript是一种编程语言，用于制作更具互动性和动态的网页。JavaScript可以设定Cookie、阅读Cookie及删除Cookie。
二、我们如何收集和使用您的个人信息
1、成为我们的用户并登录
本产品支持您使用手机号或通过第三方平台自行完成注册，成为我们的用户，也可使用由教师或学校管理人员进行创建并下发的学生、教师帐号进行登录。
在您登录后，您可以选择性地提供更多的个人信息，包括头像、昵称、身份，方便我们为您提供更好的服务。如您不提供上述额外信息，仍可以使用我们的产品或服务。
您提供的上述信息将在您使用我们提供的服务期间持续授权我们使用。在您主动注销帐号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。
2、为您提供我们的产品和服务
我们的产品主要面向学生、教师，帮助开展在线选科、了解学习动态、进行走班排课和教学评价，提供教学资源。在学生端、教师端和家长端之间进行联动。
我们根据合法、正当、必要的原则，出于如下所述的目的收集和使用您的个人信息。
1）设备信息
我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息，包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、设备设置、电池、信号强度，语言设置、分辨率、设备传感器参数、服务提供商网络ID。
2）日志信息
当您使用我们的所有业务功能时，系统会通过cookies或其他方式自动收集某些信息作为有关网络日志保存。此类信息包括：使用本产品或服务时的详细使用情况，例如您的搜索查询内容、访问的页面地址、浏览器的类型、运营商、使用的语言、访问日期和时间、设备崩溃、系统活动、访问的网页记录以及用户触发事件统计数据等。该类信息将有助于我们统计分析学生的安全上网行为。
3）其他信息
在您使用我们的产品有疑惑时，在您与我们联系时，我们可能会保存您的通信/通话记录和语音等信息或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
3. 持续开发和优化产品服务
为迭代和开发新的产品和服务，我们可能对收集的信息加以统计分析辅助决策，但形成的数据分析结果不包含您的任何身份识别信息。例如我们在提供某些功能或服务中邀请用户参与“用户体验改进计划”，加入用户体验改进计划的用户，我们会根据需要对产品或服务的各项功能使用情况进行统计，这样可以通过分析统计数据提高产品或服务质量，推出对用户有帮助的创新产品或服务提升。如您不想参与该计划，可以选择关闭相关产品/服务中的相关功能。
4. 为您提供安全保障服务
我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务用途，以提高产品和服务的安全性。当系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的相关服务。您下载或安装的安全软件会对恶意程序或病毒进行检测，为您识别诈骗信息。
5. 事先征得授权同意的例外
根据相关法律法规及国家标准，在以下情形中，我们会依法收集并使用您的个人信息无需征得您的同意：
与国家安全、国防安全直接相关的；
与公共安全、公共卫生、重大公共利益直接相关的；
与犯罪侦查、起诉、审判和判决执行等直接相关的；
出于维护您或他人的生命、财产等重大合法权益但又很难得到您本人同意的；
所收集的个人信息是您自行向社会公众公开的；
从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；
根据您的要求签订和履行合同所必需的；
用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；
法律法规规定的其他情形。
补充说明
当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。
当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
三、我们如何使用Cookie和同类技术
Cookie
为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或未提交的练习进度等数据。
我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
网站信标和像素标签
除 Cookie 外，我们还可能会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
四、我们如何对外共享、转让、披露使用您的个人信息
信息的共享
我们不会与天利教育以外的公司、组织和个人共享您的个人信息，但以下情况除外：
1）事先获得您明确的同意或授权。
2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下共享。
3）与我们的其他产品或服务共享或与我们的关联公司（说明：我们的关联公司包括“西藏丁卯科技有限公司北京分公司”）共享，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的使用及处理目的，将再次征求您的同意。
4）与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下类型：
供应商、服务提供商和其他合作伙伴。我们将信息发送在全球范围内给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务或进行学术研究和调查。
对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
信息的转让
我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
1）在获取明确同意的情况下转让：获得您的明确同意后，在授权范围内，我们会向指定其他方转让您的个人信息。
2）我们发生收购、兼并、重组等导致主体变更时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
信息的披露
我们仅会在以下情况下，公开披露您的个人信息：
1）获得您明确同意后，我们可能会公开披露您所指定的个人信息。
2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
共享、转让、披露个人信息时事先征得授权同意的例外
以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
1）与国家安全、国防安全有关的；
2）与公共安全、公共卫生、重大公共利益有关的；
3）与犯罪侦查、起诉、审判和判决执行等有关的；
4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
5）您自行向社会公众公开的个人信息；
6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
五、我们如何存储和保护您的个人信息
我们如何存储信息
1）存储信息的地点
我们遵守法律法规的规定，收集的有关您的信息和资料将保存在中华人民共和国境内我们的服务器上。以下情形除外：
法律法规有明确规定；
获得您的明确授权；
您通过互联网进行跨境交易等个人主动行为。
2）存储信息的期限
一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。用于识别您个人身份以及反映相关活动的个人信息将留存至用户注销帐号时，除非法律要求或允许在更长的期间内保留这些信息。但在下列情况下，我们因需符合法律要求，更改个人信息的存储时间：
为遵守适用的法律法规等有关规定；
为遵守法院判决、裁定或其他法律程序的规定；
为遵守相关政府机关或法定授权组织的要求；
我们有理由确信需要遵守法律法规等有关规定；
为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们的产品、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
在您终止使用我们的产品后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。
当我们的相关服务发生停止运营的情形时，我们将采取包括推送通知和公告形式在内的通知您，并在合理的期限内删除服务器中留存的您的个人信息或进行匿名化处理。
数据安全措施
1）我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。例如，我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全；我们采取加密技术（TLS、SSL）、匿名化处理和保护机制对用户个人信息进行加密保存，并通过隔离技术进行隔离；我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用；我们通过信息接触者保密协议等方式，仅允许有必要知晓这些信息的产品及产品关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制，同时要求接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，会被追究法律责任或被中止与我们的合作关系；我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
2）我们已经通过了公安部网络安全等级保护三级认证。
3）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
4）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的帐号安全。
5）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
6）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
六、您的权利
按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利，您可以参考下面的步骤进行相关操作：
访问您的个人信息
您可以通过以下步骤访问头像、姓名、学校、班级等基本信息：
web端登陆，点击头像进入个人中心，查看您的相关信息。
更改您的个人信息
您可以通过以下步骤更正您的头像、姓名、学校、班级等基本信息：
web端登陆，点击头像进入个人中心，更改您的相关信息。
删除您的个人信息
您可以通过联系校管理员，帮助您删除您的个人信息。
改变您授权同意的范围或撤回您的授权
您可以通过删除信息、关闭设备功能、在网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。
每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
注销帐号
您注销帐号后，我们将停止为您提供依赖帐号登录的产品和服务，并依据您的要求，除法律法规另有规定外，我们将删除或匿名化处理您的个人信息。
响应您的上述请求
我们将采取适当的技术手段，保证您对于自己的个人资料可进行查询、补充、更正或删除，或通过相关产品或服务发布的反馈或投诉渠道申请我们对相关信息进行补充、更正或删除；我们收到您的申请后将按流程予以处理，为保障安全，按照流程，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15日 内做出答复，对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
如果您无法访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们的产品时所产生的其他个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过我们对外公布的相关产品或服务的官方反馈渠道与我们联系。
在以下情形中，我们将无法响应您的请求：
1）与国家安全、国防安全直接相关的；
2）与公共安全、公共卫生、重大公共利益直接相关的；
3）与犯罪侦查、起诉、审判和执行判决等直接相关的；
4）我们有充分证据表明您存在主观恶意或滥用权利的；
5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
6）涉及商业秘密的。
七、我们如何处理未成年人的个人信息
我们非常重视对未成年人的个人信息保护。我们根据国家相关法律法规的规定保护未成年人的个人信息。如果没有家长或法定监护人的同意，未成年人不得创建自己的用户帐号。如您为未成年人，请在父母或监护人的陪同和帮助下仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、家长或法定监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
八、您的个人信息如何在全球范围转移
原则上，我们在中华人民共和国境内收集产生的个人信息，存储在中华人民共和国境内，您的个人信息不可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。
九、本隐私权政策如何更新
我们的隐私权政策可能变更。
未经您明确同意，我们不会削减您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何变更。同时我们会将本政策的旧版本存档，供您查阅。
对于重大变更，我们还会提供更为显著的通知，包括通过网站公示的方式进行通知甚至向您提供弹窗提示。
本政策所指的重大变更包括但不限于：
我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；
个人信息共享、转让或公开披露的主要对象发生变化；
您参与个人信息处理方面的权利及其行使方式发生重大变化；
我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
个人信息安全影响评估报告表明存在高风险时；
伴随政策或法律发布实施，为响应国家政策或者法律规范，做出变更。
十、如何联系我们
如您在使用我们的产品的过程中对本隐私政策有任何疑问或建议，请通过以下联系方式与我们联系：
公司名称：西藏天利教育科技有限公司
公司地址：西藏文化旅游创意园区拉萨次角林村林卡路5号
电 话：400-1818-075
为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在15天内回复。
如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以向天利教育住所地有管辖权的法院提起诉讼。
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, toRefs } from "vue";

import imgBigCards from "@/components/imgBigCards/index.vue";

// import { ChatDotSquare } from "@element-plus/icons-vue";

const router = useRouter();

const mydata = reactive({
  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
  textarea: "",
});

const { circleUrl, sizeList } = toRefs(mydata);
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  ////////模块1————最顶部的title
  // .title-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   // border: 1px solid blue;
  //   margin-top: 40px;
  //   margin-bottom: 20px;
  //   display: flex;
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #bbbdbf;
  //   .line {
  //     margin: 0px 8px;
  //   }
  //   p:hover {
  //     color: #009de0;
  //   }
  // }

  //////内容部分
  .box-content {
    width: 1200px;
    margin: 0 auto;
    margin-top: 40px;

    // width: 860px;
    background-color: #ffffff;
    padding: 30px;

    > p:first-of-type {
      font-size: 18px;
      font-weight: 700;
      color: #333333;

      line-height: 28px;
      // height: 56px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 1; //几行
      overflow: hidden;
    }
    > p:nth-of-type(2) {
      display: flex;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #888888;
      margin-top: 12px;
      > span {
        margin-right: 13px;
      }
    }

    > p:last-of-type {
      margin-top: 24px;
      white-space: pre-wrap;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      // border:1px solid red;
    }
  }
}
</style>